import { ArrowLeftOutlined } from '@ant-design/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { SettingsRoutes } from '../../../../../routes/settings-routes';
import { BillingPlans } from '../BillingPlans/BillingPlans';
import styles from './ManageSubsctiptionPanel.module.css';

export type ManageSubsctiptionProps = {
  accountName?: string;
  downgradePlansIds?: number[];
};

export const ManageSubsctiptionPanel = () => {
  const history = useHistory();
  const { openContactSalesModal } = useModalActions();

  const { accountName = '', downgradePlansIds } =
    (history.location.state as ManageSubsctiptionProps) || {};

  const handleBack = () => {
    history.push(SettingsRoutes.billing.getLink());
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.navigation}>
          <div className={styles.back} onClick={handleBack}>
            <ArrowLeftOutlined />
            <div>Back to Billing</div>
          </div>
        </div>
        <div className={styles.pageName}>{accountName}</div>
        <div>Manage your plan</div>
      </div>
      <BillingPlans
        hideFreePlan
        downgradePlansIds={downgradePlansIds}
        onBillingSuccess={handleBack}
      />
      <div className={styles.footer}>
        <div className={styles.footerTextContainer}>
          <div className={styles.footerHeader}>
            Not sure what is best for you?
          </div>
          <div>
            Connect with our dedicated support reps to help choose a plan that
            fits your business needs.
          </div>
        </div>
        <PrimaryButton
          className={styles.footerButton}
          color="transparent-no-shadow"
          onClick={() => openContactSalesModal({})}
        >
          Schedule Call
        </PrimaryButton>
      </div>
    </div>
  );
};
